import { capitalizeFirstLetter, stringValue } from '@/utils/helper'

export const MAX_OPTION_PAGE_SIZE = 100
export const UNLIMITED_ACCESS_THRESHOLD = 10000

export enum CALENDAR_MODE {
  LIST = 'listMonth',
  MONTHLY = 'dayGridMonth',
  WEEKLY = 'timeGridWeek',
  DAILY = 'timeGridDay',
}

export enum CALENDAR_NEW_LEAD_MODE {
  ALL = 'ALL',
  MONTHLY = 'MONTH',
  WEEKLY = 'WEEK',
  DAILY = 'DAY',
}

export enum PROGRAM_TYPE {
  PRIVATE = 'private_class',
  GROUP = 'group_class',
}

export enum PARTICIPANT_TYPE {
  KID = 'kid',
  ADULT = 'adult',
}

export enum SCHEDULE_TYPE {
  SINGLE = 'single_session',
  RECURRING = 'recurring_schedule',
}

export enum REFERRAL_CHANNEL {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TIKTOK = 'TIKTOK',
  GOOGLE = 'GOOGLE',
  WALK_IN = 'WALK_IN',
  RECOMMENDED_BY_A_FRIEND = 'REFERRED',
  EVENT = 'EVENT',
  INFLUENCER_KOL = 'INFLUENCER_KOL',
  CORPORATE = 'CORPORATE',
  OTHERS = 'OTHER',
}

/**
 * Source channels that cannot be linked to a marketing campaign.
 * (No marketing spend behind these — purely organic / external.)
 */
export const REFERRAL_CHANNELS_WITHOUT_CAMPAIGN: REFERRAL_CHANNEL[] = [REFERRAL_CHANNEL.OTHERS]

export const monthOptions = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

export const days = [
  { key: 'monday', label: 'monday' },
  { key: 'tuesday', label: 'tuesday' },
  { key: 'wednesday', label: 'wednesday' },
  { key: 'thursday', label: 'thursday' },
  { key: 'friday', label: 'friday' },
  { key: 'saturday', label: 'saturday' },
  { key: 'sunday', label: 'sunday' },
]

export const TrainerProfileLevelOptions = [
  { value: 'LEVEL_1', label: 'Level 1 - Fitness Service Instructor' },
  { value: 'LEVEL_2', label: 'Level 2 - Elite Trainer' },
  { value: 'LEVEL_3', label: 'Level 3 - Master Trainer' },
  { value: 'LEVEL_4', label: 'Level 4 - Master Coach' },
]

export const TrainerProfileTypeOptions = [
  { value: 'FREELANCE', label: 'Freelance' },
  { value: 'PERMANENT', label: 'Full Time' },
]

export const getTrainerTypeLabel = (type?: string | null) =>
  TrainerProfileTypeOptions.find((opt) => opt.value === type)?.label ||
  capitalizeFirstLetter(stringValue(type ?? undefined))

export const Levels = ['MANAGER', 'STAFF']

export const PrivateTrainingAvailableOptions = [
  { value: 'true', label: 'Available' },
  { value: 'false', label: 'Unavailable' },
]

export const yearOptions = (minYear = 2022, maxYear = new Date().getFullYear()) => {
  const years = []
  for (let i = minYear; i <= maxYear; i++) {
    years.push({ value: i, label: i.toString() })
  }
  return years
}
